/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Coverage_LabelInputs */

const en_landing_preview_coverage_label = /** @type {(inputs: Landing_Preview_Coverage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coverage`)
};

/**
* | output |
* | --- |
* | "Coverage" |
*
* @param {Landing_Preview_Coverage_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_coverage_label = /** @type {((inputs?: Landing_Preview_Coverage_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Coverage_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_coverage_label(inputs)
});